<div id="template" class="inner-template" #aboutTemp *ngIf="abt" [innerHTML]="abt | safeHtml"></div>